import { useState, useEffect, useRef } from 'react';

export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    const s = typeof d === 'string' ? d.slice(0, 10) : new Date(d).toISOString().slice(0, 10);
    const [y, m, day] = s.split('-');
    return (day && m && y) ? `${day}/${m}/${y}` : '—';
  } catch { return '—'; }
};

function toISO(text) {
  const parts = text.split('/');
  if (parts.length === 3 && parts[2].length === 4 && parts[1].length === 2 && parts[0].length === 2)
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  return '';
}

/* DateInput — text input with dd/mm/yyyy auto-formatting + calendar icon picker.
   Typed digits are always visible. value/onChange use YYYY-MM-DD. */
export function DateInput({ value, onChange, className, style, disabled, required, min, max, ...rest }) {
  const dateRef = useRef();
  const [text, setText] = useState(value ? fmtDate(value) : '');

  useEffect(() => { setText(value ? fmtDate(value) : ''); }, [value]);

  const handleText = (e) => {
    let raw = e.target.value.replace(/[^\d/]/g, '');
    const digits = raw.replace(/\//g, '');
    let formatted = digits.slice(0, 2);
    if (digits.length > 2) formatted += '/' + digits.slice(2, 4);
    if (digits.length > 4) formatted += '/' + digits.slice(4, 8);
    setText(formatted);
    const iso = toISO(formatted);
    if (iso) onChange({ target: { value: iso } });
    else if (!formatted) onChange({ target: { value: '' } });
  };

  const handlePicker = (e) => {
    onChange(e);
    setText(e.target.value ? fmtDate(e.target.value) : '');
  };

  return (
    <div style={{ position: 'relative', display: 'block', ...style }}>
      <input
        type="text"
        value={text}
        onChange={handleText}
        placeholder="dd/mm/yyyy"
        maxLength={10}
        className={className}
        disabled={disabled}
        required={required}
        style={{ width: '100%', paddingRight: 30 }}
        {...rest}
      />
      <input
        ref={dateRef}
        type="date"
        value={value || ''}
        onChange={handlePicker}
        disabled={disabled}
        min={min}
        max={max}
        tabIndex={-1}
        style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 32,
                 opacity: 0, cursor: 'pointer', zIndex: 1 }}
      />
      <span style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                     color: '#888', fontSize: 13, pointerEvents: 'none', zIndex: 2, lineHeight: 1 }}>
        📅
      </span>
    </div>
  );
}
